import CryptoJS from "crypto-js";

export function hashData(data) {
  // Hash the data using SHA-256
  return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex);
}
